import styled from "styled-components";

import { Classes, Colors } from "@blueprintjs/core";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: stretch;
  min-width: 255px;
  height: auto;
  background-color: ${Colors.DARK_GRAY4};
  & .${Classes.MENU} {
    padding: 0 !important;
  }
`;
